import { AppServerAPI } from '@sdbn/common'
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs';
import { ListResult } from '@sdbn/common-essential'

import { VehicleArchive } from "./transportmanagement.model"

@Injectable({
    providedIn: 'root'
})
export class VehicleArchiveAdministrationAPIService {

  constructor (
    private appServerAPI: AppServerAPI
  ) {
  }

  public getAll() : Subject<ListResult<VehicleArchive>> {
    const subject = new Subject<ListResult<VehicleArchive>>();
    this.appServerAPI.execute<ListResult<VehicleArchive>>('/TMC-YARD/TransportManagement/VehicleArchiveAdministration/getAll', null).subscribe(response => {
      let result = new Array<VehicleArchive>();
      for (const item of response.values) {
        result.push(new VehicleArchive(item));
      }
      subject.next(new ListResult<VehicleArchive>(result, response.dataSetCount));
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

  public get(id: string) : Subject<VehicleArchive> {
    const subject = new Subject<VehicleArchive>();
    this.appServerAPI.execute<VehicleArchive>('/TMC-YARD/TransportManagement/VehicleArchiveAdministration/get', id).subscribe(response => {
      subject.next( new VehicleArchive(response));
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

  public delete(theme: VehicleArchive) : Subject<boolean> {
    const subject = new Subject<boolean>();
    this.appServerAPI.execute<boolean>('/TMC-YARD/TransportManagement/VehicleArchiveAdministration/delete', theme).subscribe(response => {
      subject.next( response);
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

  public save(coloringTheme: VehicleArchive) : Subject<boolean> {
    const subject = new Subject<boolean>();
    this.appServerAPI.execute<boolean>('/TMC-YARD/TransportManagement/VehicleArchiveAdministration/save', coloringTheme).subscribe(response => {
      subject.next( response);
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

}
